<template>
  <div>
    <!-- 头部 -->
    <div class="new_top">
      <header2></header2>
      <navigation></navigation>
    </div>
    <!--中间主体-->
    <div class="new_content">
      <div class="nc_pindao_title">
        <p class="ncpt_line"></p>
        <span>{{$route.query.subjectName}}</span>
      </div>
      <div class="nc1">
        <div class="ncn_pic_subject f_l">
          <div id="flexslider">
            <el-carousel trigger="click" height="265px">
              <el-carousel-item v-for="item in secondCarousel" :key="item.id">
                <a target="_blank" :href="item.url"><img :src="item.imgUrl" width="545" height="265"/></a>
                <p class="flex-caption">{{item.title}}</p>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <newsSimpleList class="f_r ncn_text2" :settings="trainingDynamicNewsSettings"></newsSimpleList>
      </div>
      <!--  前沿动态 病例讨论 行业信息 学术会议  -->
      <medicalDynamicNews :parentTagId="$route.query.subject1?$route.query.subject1.toString():$route.query.subject1" :tagId="$route.query.subject2?$route.query.subject2.toString():$route.query.subject2"></medicalDynamicNews>
      <!-- 精品课程 -->
      <perfectCourseSimpleList :perfectPosition="perfectPosition" orPerfectPosition="3,0;"></perfectCourseSimpleList>
    </div>
    <footer1></footer1>
  </div>
</template>

<script>
  import {getRecommendList} from '../api/api';
  import  header2 from '../components/Header2'
  import  navigation from '../components/Navigation'
  import  footer1 from '../components/Footer1'
  import  login from '../components/Login'
  import  newsSimpleList from '../components/NewsSimpleList'
  import  perfectCourseSimpleList from '../components/PerfectCourseSimpleList'
  import  medicalDynamicNews from '../components/MedicalDynamicNews'
  export default {
    components: {
      header2,
      footer1,
      navigation,
      login,
      newsSimpleList,
      perfectCourseSimpleList,
      medicalDynamicNews
    },
    data () {
      return {
        trainingDynamicNewsSettings: {//获取培训动态资讯
          isSubject: true,
          consultId: 6,
          parentTagId:this.$route.query.subject1,
          tagId:this.$route.query.subject2,
          publishState: 0,
          publishTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
          'displayPositionIds': [1, 3],
          'projectIdsC': [],
          'orderWeight': true,
          orderPublishTime: true,
          pageNum: 1,
          pageSize: 5,
        },
        secondCarousel: null,
        perfectPosition:"3,"+(this.$route.query.subject2?this.$route.query.subject2:this.$route.query.subject1+";")
      }
    },
    mounted () {
      getRecommendList({
        pageNum: 0,
        pageSize: 4,
        posf: 3,
        posc: this.$route.query.subject2?this.$route.query.subject2:this.$route.query.subject1,
        order: 1
      }).then((response) => {//获取轮播图2
        this.secondCarousel = response.data.data.list;
      })
    },
    computed: {
    },
    methods: {}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  /* CSS Document */
  .zyzg {
    width: 1000px;
    margin: 0px auto;
    margin-top: -20px;
  }

  .zy_top_jg {
    width: 100%;
    background: url(../assets/images/jg_top.gif) no-repeat center center;
    height: 58px;
  }

  .zy_bottom_jg {
    width: 100%;
    background: url(../assets/images/jg_bottom.gif) no-repeat center center;
    height: 58px;
  }

  .zy_jg2 {
    width: 100%;
    text-align: center;
    background: url(../assets/images/jg2.gif) no-repeat center top;
    height: 80px;
  }

  .zyjg2_1 {
    font-size: 25px;
    line-height: 30px;
  }

  .zyjg2_2 {
    font-size: 14px;
    line-height: 30px;
    color: #818181;
  }

  .zy_table {
    width: 920px;
    margin: 0 auto;
    padding-bottom: 12px;
  }

  .zy_table table {
    border-left: 1px #95c9dc solid;
    border-top: 1px #95c9dc solid;
  }

  .zy_table table tr td {
    border-right: 1px #95c9dc solid;
    border-bottom: 1px #95c9dc solid;
    line-height: 30px;
    font-size: 16px;
    text-align: center
  }

  .zy_table table tr td span {
    color: #3ac1f3;
  }

  .zy_zf {
    width: 100%;
    padding-top: 5px;
  }

  .zyzf_title {
    height: 42px;
    line-height: 42px;
    color: #1e88d0;
    font-size: 20px;
    font-weight: bold;
    text-align: left;
  }

  .zyzf_main {
    width: 447px;
    border: 1px #ddd solid;
    background: #f3f3f3;
    padding: 20px 0px;
    height: 218px;
  }

  .zyzfm_left {
    width: 251px;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    line-height: 24px;
    padding-top: 30px;
  }

  .zyzfm_left span {
    font-size: 20px;
    color: #1e88d0;
  }

  .zyzfm_right {
    border: 1px #ddd solid;
    padding: 5px;
    background: #fff;
  }

  .zyzf_cell {
    width: 449px;
  }

  .zyzfc {
    width: 423px;
    border: 1px #ddd solid;
    background: #fff;
    height: 160px;
    padding: 20px 12px 0px 12px;
    color: #1e88d0;
    height: 198px;
  }

  .zyzfc2 {
    width: 447px;
    border: 1px #ddd solid;
    background: #f3f3f3;
    height: 218px;
  }

  .zyzf2_title {
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: #1e88d0;
    font-size: 20px;
    font-weight: bold;
  }

  .zyzf2_left {
    width: 251px;
    float: left;
    text-align: center;
  }

  .zyzf2_left p {
    display: block;
    font-size: 16px;
    font-weight: bold;
    line-height: 24px;
  }

  .zyzf2_left p span {
    font-size: 14px;
  }

  .zyzf2_right {
    width: 141px;
    height: 141px;
    border: 1px #ddd solid;
    padding: 5px;
    background: #fff;
    float: left;
  }

</style>



// WEBPACK FOOTER //
// src/views/SecondSubject.vue